export default {"src":"/_next/static/media/ANET.933ba8eb.svg","height":18,"width":18};